var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramTools128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/xLarge./Tools128",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calc",
    transform: "translate(18.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    stroke: "#4F4C4D",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 1.5,
    y: 1.5,
    width: 89,
    height: 89
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Focus",
    stroke: "#4F4C4D",
    strokeWidth: 3,
    fill: "#FFCC00",
    x: 46,
    y: 46,
    width: 44.5,
    height: 44.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Axis",
    transform: "translate(3.000000, 3.000000)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Horizontal",
    x: 0,
    y: 41.5,
    width: 86,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Vert",
    x: 41.5,
    y: 0,
    width: 3,
    height: 86
  })), /*#__PURE__*/React.createElement("g", {
    id: "Multiply",
    transform: "translate(17.250000, 61.750000)",
    stroke: "#4F4C4D",
    strokeLinecap: "square",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.208333333,12.8371212 L12.7537879,0.291666667",
    id: "LineDiagR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.208333333,0.291666667 L12.7537879,12.8371212",
    id: "LineDiagL"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(13.250000, 13.250000)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Horizontal",
    x: 0,
    y: 9,
    width: 21,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Vert",
    x: 9,
    y: 0,
    width: 3,
    height: 21
  })), /*#__PURE__*/React.createElement("g", {
    id: "Minus",
    transform: "translate(60.000000, 22.000000)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0.25,
    width: 17,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Equals",
    transform: "translate(58.000000, 61.000000)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bottom",
    x: 0,
    y: 11,
    width: 20,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Top",
    x: 0,
    y: 1,
    width: 20,
    height: 3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramTools128);
export default __webpack_public_path__ + "static/media/pictogramTools128.923baf758e4030f4d2ca018b1a49ccd0.svg";
export { ForwardRef as ReactComponent };